import React, { useState } from 'react';
import './SeloAsaas.css';

/* =========================================================================
   SeloAsaas — Selo de conformidade BaaS (Resolução Conjunta nº 16/2025)
   -------------------------------------------------------------------------
   Componente único e reutilizável em QUALQUER fluxo que envolva
   movimentação/gestão de valores: geração de cobrança, checkout,
   comprovantes, extratos, criação de subconta.

   Uso:
     <SeloAsaas />                         // positivo, clicável (padrão)
     <SeloAsaas variante="negativoBranco" clicavel /> // p/ fundos escuros
     <SeloAsaas largura={120} altura={36} legenda />

   As URLs são as homologadas individualmente para o tenant. Se um dia o
   Asaas trocar a arte, o SVG é atualizado na CDN deles — o projeto não quebra.
   ========================================================================= */

const SELO_URLS = {
  positivo:
    'https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Positivo.svg?id=95610fd7-510b-41ce-b552-d03b20d7f9ae',
  negativoPreto:
    'https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Negativo-Preto.svg?id=95610fd7-510b-41ce-b552-d03b20d7f9ae',
  negativoBranco:
    'https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Negativo-Branco.svg?id=95610fd7-510b-41ce-b552-d03b20d7f9ae',
};

const ALT = 'Serviços financeiros processados por Asaas';

export default function SeloAsaas({
  variante = 'positivo',
  largura = 160,
  altura = 48,
  clicavel = true,
  legenda = false,
  className = '',
}) {
  const [falhou, setFalhou] = useState(false);
  const src = SELO_URLS[variante] || SELO_URLS.positivo;

  // Fallback textual — mantém a conformidade mesmo se a CDN cair.
  if (falhou) {
    return (
      <span className={`selo-asaas selo-asaas--fallback ${className}`}>
        Serviços financeiros por <strong>Asaas</strong>
      </span>
    );
  }

  const img = (
    <img
      src={src}
      alt={ALT}
      title={ALT}
      width={largura}
      height={altura}
      loading="lazy"
      onError={() => setFalhou(true)}
      className="selo-asaas__img"
      style={{ display: 'inline-block' }}
    />
  );

  const conteudo = clicavel ? (
    <a
      href="https://asaas.com"
      target="_blank"
      rel="noopener noreferrer"
      className="selo-asaas__link"
      aria-label="Abrir o site do Asaas em nova aba"
    >
      {img}
    </a>
  ) : (
    img
  );

  return (
    <span className={`selo-asaas ${className}`}>
      {conteudo}
      {legenda && (
        <span className="selo-asaas__legenda">
          Instituição de pagamento autorizada pelo Banco Central
        </span>
      )}
    </span>
  );
}